import React from 'react'
import { Form, Table } from "react-bootstrap"
export default function DeliveryLists() {
    return (
        <Table responsive>
            <thead>
                <tr style={{ alignItems: "center", whiteSpace: "nowrap" }}>
                    <th style={{ borderBottom: "none", alignItems: "center" }}>
                        <Form.Check
                            inline
                            id="ລຳດັບ"
                            label="ລຳດັບ"
                            type="checkbox"
                        />
                    </th>
                    <th style={{ borderBottom: "none" }}>ຮູບສິນຄ້າ</th>
                    <th style={{ borderBottom: "none" }}>ຊື່ສິນຄ້າ (ລະຫັດ CF)</th>
                    <th style={{ borderBottom: "none" }}>ຈຳນວນ</th>
                    <th style={{ borderBottom: "none" }}>ລາຄາຂາຍ</th>
                    <th style={{ borderBottom: "none" }}>ລາຄາຕົ້ນທືນ</th>
                    <th style={{ borderBottom: "none" }}>ວັນທີ່ສ້າງສິນຄ້າ</th>
                    <th style={{ borderBottom: "none" }}>ໃຊ້ເຊວເພຈ</th>
                    <th style={{ borderBottom: "none" }}>ຈັດການ</th>
                </tr>
            </thead>
        </Table>
    )
}
